/*
 * Routes-coupons.ts
 * Description: Includes the declaration of the
 * coupon routes for Vue Router
 */

// Importing components
import PageCoupons from '@/pages/coupons/PageCoupons.vue';
import PageCouponsCreate from '@/pages/coupons/PageCouponsCreate.vue';

const routesCoupon = [
    // Defining the coupon page route
    {
        path: '/restaurants/:id/coupon',
        name: 'coupons',
        component: PageCoupons,
        props: { id: Number },
        meta: { requiresAuth: true, ManageOrders: true },
    },
    // Defining the coupon create page route
    {
        path: '/restaurants/:id/coupon/create',
        name: 'coupons-create',
        component: PageCouponsCreate,
        props: { id: Number },
        meta: { requiresAuth: true, ManageOrders: true },
    },
];
export default routesCoupon;
